import { useState } from 'react'
import { assigneeLabel, useAssignableBuyers } from '../hooks/useAssignableBuyers'

/**
 * Назначить отмеченные позиции закупщику или РОЗ (видимость в очереди квот):
 * выпадашка + «Применить». Общая для панели продаж (SelectedItemsBar) и панели
 * РОЗ (ProcurementSelectedBar, №50, 29.09.2026). Список — `useAssignableBuyers`:
 * у РОЗ это она сама и её команда. «— Показать всем —» снимает назначение.
 * Назначаются только позиции «Китай»/«Производители» — остальные сервер
 * пропускает, об этом сообщает хук назначения.
 */
export function AssignSelectedControl({
  placeholder,
  isAssigning,
  onAssign,
}: {
  placeholder: string
  isAssigning: boolean
  onAssign: (assignedToId: string | null) => void
}) {
  const buyers = useAssignableBuyers()
  const [value, setValue] = useState('')

  if (buyers.length === 0) return null

  const handleAssign = () => {
    if (!value || isAssigning) return
    onAssign(value === '__none__' ? null : value)
  }

  return (
    <div className="flex items-center gap-1.5">
      <select
        value={value}
        onChange={(e) => setValue(e.target.value)}
        disabled={isAssigning}
        className="px-2 py-1 text-xs border border-gray-200 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-brand-500 disabled:opacity-50"
        aria-label="Назначить выбранные позиции"
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {buyers.map((pu) => (
          <option key={pu.id} value={pu.id}>
            {assigneeLabel(pu)}
          </option>
        ))}
        <option value="__none__">— Показать всем —</option>
      </select>
      <button
        onClick={handleAssign}
        disabled={!value || isAssigning}
        className="px-3 py-1.5 text-xs bg-brand-600 text-white rounded-lg hover:bg-brand-700 disabled:opacity-50"
      >
        {isAssigning ? 'Применение…' : 'Применить'}
      </button>
    </div>
  )
}
